import { MUTE_INCOMING_CALL } from "../../CONSTANTS";

export default function muteIncomingCall({ callId }) {
  return {
    type: MUTE_INCOMING_CALL,
    payload: {
      callId,
    },
  };
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/actions/calls/muteIncomingCall.js